module.exports = __webpack_public_path__ + "img/yz.f24f79bb.png";